import React from "react";
import NavBar from "../components/NavBar/NavBar";
import Footer from "../components/Footer/Footer";
import HeroContactus from "./HeroContactus/HeroContactus";

export default function Contactus() {
  return (
    <div>
      <NavBar />
      <HeroContactus />
      <Footer />
    </div>
  );
}
